module.exports = __webpack_public_path__ + "static/img/bg2.90035d0f.jpg";